import type { States } from '@ps/web-shared-components';
import React from 'react';

import states from '@swf/generated/states.json';

import type { Props as SelectProps } from '../Select/Select';
import Select from '../Select/Select';

import State from './components/State/State';

type Props = Partial<SelectProps>;

export const getCountryStates = (selectedCountry: string): States => states[selectedCountry] || [];

const StateSelect: React.FC<Props> = ({ children, country, title, name = 'state', ...props }) => (
  <Select name={name} options={getCountryStates(country)} item={State} title={title} {...props}>
    {children}
  </Select>
);

export default StateSelect;
